export default "__VITE_ASSET__Ceixdbcp__"